/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Ladda = require('ladda');

var BreadcrumbView = require('common/views/BreadcrumbView');
var HeaderBarView = require('common/views/HeaderBarView');
var SpinnerView = require('common/views/SpinnerView');
var EmptyView = require('common/views/EmptyView');
var FileUploadView = require('common/views/FileUploadView');
var modelGet = require('common/util/modelGet');
var makeUploadCollection = require('common/util/makeUploadCollection');
var GenerateAdHocDocument = require('../../common/services/GenerateAdHocDocument');

require('../styles/NonDepInternalApplicationDelinquencyDocGenView.css');
var tmplNonDepInternalApplicationDelinquencyDocGenView = require('../templates/NonDepInternalApplicationDelinquencyDocGenView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepInternalApplicationDelinquencyDocGenView,

  className: 'non-dep-internal-application-delinquency-doc-gen-view container-fluid',

  ui: {
    headerBar: '.header-bar',
    breadcrumb: '.breadcrumb-container',
    documentContainer: '.document-container',
    docGenForm: '.doc-gen-form',
    downloadContainer: '.download-container',
    submit: '.submit'
  },

  regions: {
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb',
    documentContainer: '@ui.documentContainer',
    downloadContainer: '@ui.downloadContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var entityId = modelGet(this.model, 'applicationDetails.entityId');
    var entityName = modelGet(this.model, 'applicationDetails.entityName');
    var applicationId = modelGet(this.model, 'applicationDetails.applicationId');
    var applicationType = modelGet(this.model, 'applicationDetails.applicationType');
    var applicationStatus = modelGet(this.model, 'applicationDetails.applicationStatus');

    var headerData = {
      title: 'Application',
      applicationType: applicationType,
      status: applicationStatus,
      owner: this.model.get('owner')
    };

    this.showChildView(
      'headerBar',
      new HeaderBarView({
        columns: new Backbone.Collection([
          {
            name: 'applicationType',
            label: 'Application Type',
            minWidth: '160px',
            maxWidth: '300px'
          },
          {
            name: 'owner',
            label: 'Owner',
            minWidth: '160px'
          },
          {
            name: 'status',
            label: 'Status',
            minWidth: '160px',
            maxWidth: '350px',
            overflow: 'truncate'
          }
        ]),
        model: new Backbone.Model(headerData)
      })
    );

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#nondep/dashboard',
            text: 'Home'
          },
          {
            link: '#nondep/entity/' + entityId + '/dashboard',
            text: entityName
          },
          {
            link: '#nondep/application/' + applicationId + '/dashboard',
            text: 'Application #' + applicationId + ' - ' + applicationType
          },
          {
            text: 'Generate Delinquency Letter'
          }
        ]
      })
    );
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;

    this.validate().done(function() {
      var l = Ladda.create(self.ui.submit[0]);
      l.start();

      // Show spinner where document will appear
      self.showChildView(
        'documentContainer',
        new SpinnerView({
          spinner: {
            scale: '0.5'
          }
        })
      );

      var formData = self.getFormData();
      formData.applicationId = modelGet(self.model, 'applicationDetails.applicationId');
      formData.applicationType = modelGet(self.model, 'applicationDetails.applicationType');
      formData.documentTemplateName = 'ND_DELINQUENCY_LETTER_TEMPLATE';

      // Show label for downloaded document
      self.ui.downloadContainer.show();

      // Show spinner where document will appear
      self.showChildView(
        'documentContainer',
        new SpinnerView({
          spinner: {
            scale: '0.5'
          }
        })
      );

      GenerateAdHocDocument(formData)
        .done(function(file) {
          self.showChildView(
            'documentContainer',
            new FileUploadView({
              isReadOnly: true,
              collection: makeUploadCollection(file)
            })
          );
          l.stop();
        })
        .fail(function() {
          l.stop();
          self.showChildView('documentContainer', new EmptyView());
        });
    });
  },

  validate: function() {
    return this.ui.docGenForm.parsley().whenValidate();
  },

  getFormData: function() {
    return Syphon.serialize(this);
  }
});
